<template>
    <modal @close="clickCancel" dialog="modal-lg" class="dark-top heightAuto" :footer="true">

        <div slot="title">
            <h2>Booking Question</h2>
        </div>

        <div slot="body" class="d-flex flex-column">
            <div class="m-4">
                <h3>{{reservation.event.bookingQuestion}}</h3>
                <!-- <textarea class="mt-3" placeholder=""></textarea> -->
                <input type="text" class="w-100 mt-3" v-model="reservation.customer.bookingAnswer">
            </div>
        </div>

        <div slot="footer">
            <button type="button" class="btn cancel widest" @click="clickCancel">Cancel</button>
            <button type="button" class="btn ok widest" :disabled="disabled" @click="clickContinue">Continue</button>
        </div>


    </modal>
</template>

<script>

    import { mapActions, mapGetters } from 'vuex'
    import { required, email, minLength } from 'vuelidate/lib/validators'
    import Modal from './Modal'

    export default {
        data: function () {
            return {
            }
        },
        created: function() {
            this.$set(this.getReservation.customer, 'bookingQuestion', this.reservation.event.bookingQuestion)
            if(!this.reservation.customer.bookingAnswer){
                this.$set(this.reservation.customer, 'bookingAnswer', null)
            }
        },
        validations: {
            // userAccount: {
            //     email: {
            //         required,
            //         email,
            //         isUnique: function() {
            //             return this.isUniqueEmail() || true
            //         }
            //     },
            //     name: {
            //         required,
            //         minLength: minLength(3)
            //     }
            // }
        },
        computed: {
            ...mapGetters([
                'getReservation'
            ]),
            reservation: function () {
                return this.getReservation
            },
            disabled: function () {
                return this.reservation.event.bookingQuestionIsMandatory && this.reservation.event.bookingQuestionIsMandatory == true && (this.reservation.customer.bookingAnswer == null || this.reservation.customer.bookingAnswer.length < 1)
            }
        },
        methods: {
            ...mapActions([
                'closeModal',
            ]),

            clickCancel: function() {
                this.closeModal('cancel');
            },
            clickContinue: function() {
                this.closeModal('ok');
            }
        },
        components: {
            Modal,
        }
    }
</script>

<style lang="scss">
    @import '../../assets/scss/_variables.scss';

</style>



// WEBPACK FOOTER //
// bookingQuestion.vue?7eecd2d8